import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { TAX_TYPES } from '../../utils/taxTypes';

const TaxTypeSelect = ({ name, label = 'Tax Category', control, errors, readOnly = false, setValue, index }) => {
  const taxTypes = useSelector((state) => state.taxTypes.taxTypes);
  const taxTypesOptions = taxTypes.map((item) => {
    return { key: item.Code, value: item.Description };
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id="tax_category"
            options={taxTypesOptions}
            readOnly={readOnly}
            getOptionLabel={(option) => option.value}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(_, value) => {
              field.onChange(value);
              if (value?.key === TAX_TYPES.NotApplicable.Code && setValue && index !== undefined) {
                setValue(`taxes.${index}.value`, 0);
              } else if (value?.key === TAX_TYPES.TourismTax.Code && setValue && index !== undefined) {
                setValue(`taxes.${index}.type`, 'absolute');
              }
            }}
            value={field.value}
          />
        );
      }}
    />
  );
};

export default TaxTypeSelect;
